import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { NotificationDetailView } from '@/apis/service/notifications';

type Props = {
  detail: NotificationDetailView;
};

export default function StandardNotificationBody({ detail }: Props) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ py: 0.5 }}>
      {detail.sender ? (
        <Box>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.25 }}>
            {t('notifications.sender')}
          </Typography>
          <Typography variant="body2">{detail.sender}</Typography>
        </Box>
      ) : null}
      {detail.content ? (
        <Box
          component="div"
          sx={{ typography: 'body2', '& p:last-child': { mb: 0 } }}
          dangerouslySetInnerHTML={{ __html: detail.content }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          —
        </Typography>
      )}
    </Stack>
  );
}
